<template>
  <fragment v-if="!delegate.proposta.restituicao">
    <h2 class="pt-0 pb-3 lightblue--text">Forma de Pagamento</h2>
    <v-layout row wrap>
      <v-flex xs12>
        <v-label>Nº de parcelas</v-label>
        <v-select
          v-model="selectedInstallment"
          :items="delegate.proposta.parcelamentos_disponiveis"
          @input="onSelectInstallment"
          item-text="ds_parcelamento"
          class="jns-input"
          return-object
          outlined
        />
      </v-flex>
      <v-flex xs6>
        <v-label>1º Parcela</v-label>
        <v-text-field class="jns-input" disabled :value="firstParcelValue" />
      </v-flex>
      <v-flex xs6>
        <v-label>Dias para o vencimento</v-label>
        <v-select
          v-model="selectedDiasPrimeiraParcela"
          :items="delegate.proposta.parametros.dias_vencimento_primeira_parcela"
          @input="onSelectDiasPrimeiraParcela"
          item-text="dia_para_pagamento"
          class="jns-input"
          return-object
          outlined
        />
      </v-flex>
      <v-flex v-if="delegate.recusada_por_limite" x8>
        <div class="msg_limites">
          <span
            >Tomador não possui mais Limite de Crédito para realizar a emissão
            desta Apólice.</span
          >
        </div>
      </v-flex>
    </v-layout>
  </fragment>
</template>

<script lang="js">
import { toMoneyString } from "@/libs/utils";

export default {
  name: "FormPagamnentoForm",
  props: ["delegate"],
  data() {
    return {
      selectedInstallment: this.delegate.proposta.parcelamentos_disponiveis[0],
      selectedDiasPrimeiraParcela: this.delegate.proposta.parametros.dias_vencimento_primeira_parcela[0]
    };
  },
  computed: {
    firstParcelValue() {
      return toMoneyString(this.selectedInstallment?.detalhes?.valor_parcela);
    },
    additionalFractionation() {
      return toMoneyString(this.selectedInstallment?.detalhes?.adicional_fracionamento);
    },
  },
  methods: {
    onSelectInstallment() {
      this.$emit("select-installment", this.selectedInstallment);
    },
    onSelectDiasPrimeiraParcela() {
      this.$emit("select-dias-primeira-parcela", this.selectedDiasPrimeiraParcela);
    }
  }
};
</script>



// WEBPACK FOOTER //
// ./src/components/Apolice/Steps/FormaPagamentoForm.vue